import {
  PRIVATE_MODE_SX,
  usePatientPrivacy
} from "hooks/use-patient-privacy.hook";
import type { ContactKind } from "services/dialstack";

export type ContactPrivacySx = Partial<typeof PRIVATE_MODE_SX>;

// A family contact is PHI-adjacent (a patient's relative), so in privacy mode
// everything that identifies it — initials, name, organization, numbers,
// email, notes — blurs the way a patient's name does. A business contact
// stays readable. Spread the result into the `sx` of each text node.
export function isContactBlurred(
  isPrivateMode: boolean,
  kind: ContactKind | undefined
) {
  return isPrivateMode && kind === "family";
}

export default function useContactPrivacySx(
  kind: ContactKind | undefined
): ContactPrivacySx {
  const { isPrivateMode } = usePatientPrivacy();
  return isContactBlurred(isPrivateMode, kind) ? PRIVATE_MODE_SX : {};
}
